import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "antd";
import svg74 from "../../assets/svg/svg74.svg";
import svg75 from "../../assets/svg/svg75.svg";
import svg76 from "../../assets/svg/svg76.svg";
import { fetchData } from "../../features/fetch/fetchSlice";
import { useEffect, useState } from "react";
import CardLoading from "../../components/CardLoading";
import EmtyCard from "../../components/EmtyCard";

const items = [
  {
    title: "NdovuPay Main",
    subTitle:
      "Access the main payment platform with full financial services and management tools.",
    svg: "svg74",
    btnTitle: "NdovuPay Main",
  },
  {
    title: "ScanTrack",
    subTitle:
      "Manage event attendance via biometric scans and automate payment disbursements.",
    svg: "svg75",
    btnTitle: "Open ScanTrack",
  },
];
export default function ChooseScreen() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const url = "api/v1/org-services/fetch-org-services";

  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const { user } = useSelector((state) => state.auth);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const fetchTableData = (page = pageIndex, size = pageSize) => {
    dispatch(fetchData({ url, start: page, limit: size }));
  };

  useEffect(() => {
    fetchTableData();
  }, []);

 
  const token = localStorage.getItem("token");
  const handleNavigate = async (item) => { 
    if (item?.serviceName == "NDOVUPAY") {
      navigate("/dashboard");
    } else {
      window.location.href = `${item?.serviceLink}?code=${token}`;
    }
  };  
  const svgMap = {
    svg74,
    svg75,
  };
  const processedData =
    data &&
    data?.map((item) => ({
      ...item,
      svg: svgMap[item?.serviceIcon],
    }));

 if (loading) return <CardLoading />;

  return (
    <>
      <div className="relative flex flex-col lg:flex-row w-full min-h-screen overflow-y-auto h-screen">
        <div className="hidden lg:block lg:w-1/2 login-choose-pic" />

        <div className="hidden lg:flex lg:w-1/2 bg-white items-center justify-center" />

        <div className="flex lg:hidden w-full bg-white flex-col items-center justify-center px-4 sm:px-6 py-8">
          <div className="text-[#111827] text-2xl sm:text-3xl font-[600] leading-tight text-center">
            Hi, {user?.userName}
          </div>

          {processedData?.length > 0 ? (
            <>
              <div className="text-[#000] text-sm sm:text-base font-[400] mt-1 text-center">
                Choose where you want to go today.
              </div>

              <div className="mt-6 sm:mt-8 grid gap-4 grid-cols-1 sm:grid-cols-2 w-full max-w-md">
                {processedData?.map((item) => (
                  <div
                   onClick={() => handleNavigate(item)}
                    key={item?.orgServiceId}
                    className="rounded-xl border border-[#E5E7EB] bg-white shadow-sm w-full p-6 sm:p-8 flex flex-col items-center cursor-pointer hover:shadow-md transition-shadow"
                  >
                    <div className="bg-[rgba(255,182,0,0.10)] rounded-[1rem] w-12 h-12 flex items-center justify-center">
                      <img
                        src={item?.svg ?? svg74}
                        alt={item?.svg ?? "svg74"}
                        className="w-6 h-6"
                      />
                    </div>

                    <div className="mt-4 text-[#111827] text-lg sm:text-xl font-[600]">
                      {item?.serviceName}
                    </div>

                    <div className="mt-2 text-[#4B5563] text-sm font-[300] leading-[1.25rem] text-center">
                      {item?.serviceDescription}
                    </div>

                    <div className="mt-4 text-[#000] text-sm font-[400] flex items-center gap-[.25rem] cursor-pointer">
                      Open {item?.serviceName}
                      <img src={svg76} alt="svg76" className="w-4 h-4" />
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="mt-6 sm:mt-8">
              <EmtyCard title="No services have been added for this organization. Please contact your administrator." />
            </div>
          )}
        </div>

        <div className="absolute inset-0 hidden lg:flex items-center justify-center px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center w-full max-w-6xl">
            <div className="text-[#111827] text-2xl sm:text-3xl lg:text-[1.875rem] font-[600] leading-tight text-center">
              Hi, {user?.userName}
            </div>

            {processedData?.length > 0 ? (
              <>
                <div className="text-[#000] text-sm sm:text-base lg:text-[1rem] font-[400] mt-1 text-center">
                  Choose where you want to go today.
                </div>

                <div className="mt-6 sm:mt-8 lg:mt-[1.88rem] grid gap-4 grid-cols-1 sm:grid-cols-2">
                  {processedData?.map((item) => (
                    <div
                      onClick={() => handleNavigate(item)}
                      key={item?.orgServiceId}
                      className="rounded-xl border border-[#E5E7EB] bg-white shadow-sm w-full sm:w-[20rem] lg:w-[23rem] p-6 sm:p-8 lg:p-[2.0625rem] flex flex-col items-center cursor-pointer hover:shadow-md transition-shadow"
                    >
                      <div className="bg-[rgba(255,182,0,0.10)] rounded-[1rem] w-12 h-12 lg:w-[3.125rem] lg:h-[3.125rem] flex items-center justify-center">
                        <img src={item?.svg} alt={item?.svg} className="w-6 h-6" />
                      </div>

                      <div className="mt-4 lg:mt-[1rem] text-[#111827] text-lg sm:text-xl lg:text-[1.25rem] font-[600]">
                        {item?.serviceName}
                      </div>

                      <div className="mt-2 lg:mt-[.5rem] text-[#4B5563] text-sm lg:text-[.875rem] font-[300] leading-[1.25rem] text-center">
                        {item?.serviceDescription}
                      </div>

                      <div className="mt-4 lg:mt-[1rem] text-[#000] text-sm lg:text-[.875rem] font-[400] leading-[1.25rem] flex items-center gap-[.25rem] cursor-pointer">
                        Open {item?.serviceName}
                        <img src={svg76} alt="svg76" className="w-4 h-4" />
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="mt-6 sm:mt-8 lg:mt-[1.88rem]">
                <EmtyCard title="No services have been added for this organization. Please contact your administrator." />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
